/**
 * Headers for raw fetch() calls to admin API routes, which all require the
 * admin bearer token. (apiClient adds it automatically; plain fetch does not.)
 */
export function adminAuthHeaders(extra: Record<string, string> = { 'Content-Type': 'application/json' }): Record<string, string> {
  const token = localStorage.getItem('token');
  return token ? { ...extra, Authorization: `Bearer ${token}` } : extra;
}
